// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { configurations } from "./configurations/configurations";

export const environment = {
  production: false,
  endPoints: {
    api: {
      baseName: 'Api',
      api: 'api',
       scopes: [
         'https://devinvitaliab2c.onmicrosoft.com/11f65f83-c3ac-41eb-b553-85494b418bb4/ReadUser',
       ],
    },
  },
  clientId: '11f65f83-c3ac-41eb-b553-85494b418bb4',
  ...configurations,
  b2cPolicies: {
    names: {
      signUpSignIn: "B2C_1A_SIGNIN_PAPPS"
    },
    authorities: {
      signUpSignIn: {
        authority: "https://devinvitaliab2c.b2clogin.com/devinvitaliab2c.onmicrosoft.com/B2C_1A_SIGNIN_PAPPS"
      }
    },
    authorityDomain: "devinvitaliab2c.b2clogin.com"
  }
  // authorityBaseUrl:
  //   'https://minervaorgdevb2c.b2clogin.com/minervaorgdevb2c.onmicrosoft.com/',
  // policyB2cName: 'B2C_1A_INVITALIA_SIGNIN',
  // policyB2cCustomUI: 'default',
  // authorityDomain: 'minervaorgdevb2c.b2clogin.com',
  // instrumentationKey: '62fcd409-09d6-4a55-bae3-becffca50dc0',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
